// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21yAD","title":"styles_title__3_OHS"};